import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 63.68 72.54"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m49.06 20.9 4.5 10.71-2.05-.04-7.78-10.68s-2.06-.04-2.87-.07c-.35-.01-.82-.03-1.34-.11-.7 4.3-1.64 9.92-2.84 16.06-2.36 12.01-2.17 20.51-12.56 20.51-3.3 0-6.41-1.5-6.42-3.94-.02-4.39.65-11.99.65-11.99L.79 41.27S0 48.58 0 56.38c0 7.06 7.73 16.22 23.02 16.17 11.67-.04 19.41-2.76 26.13-12.28 3.36-4.76 5.02-16.06 7.64-28.43.76-3.6 1.54-7.22 2.28-10.67l-.69-.8-9.32.54ZM54.37.03c-3.41.06-7.48.73-9.77 3.47-2.29 2.75-3.56 8-4.13 11.33-.14.84-.31 1.88-.5 3.08.34-.03.65-.05.89-.05.82-.03 2.87-.07 2.87-.07l7.78-10.68 2.05-.05-4.5 10.71 9.33.54 1.74-2.02c2-9.25 3.55-16.26 3.55-16.26s-5.89-.06-9.31 0Z",
      style: {"fill":"#ef4138"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "LS-logo"}) } }